<app-header></app-header>  

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">Pricing Table</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- Pricing section -->
<div class="section border-top">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Pricing Table</span></h6>
                <h2 class="fw-semi-bold mb-0 text-capitalize animate-text">Designing Experiences That Inspire.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-5 text-center">
            <div *ngFor="let plan of pricingPlans" class="col-12 col-md-4 img-class">
                <div class="bg-white box-shadow hover-float border-radius p-4" [ngClass]="{ 'mt-lg-4': plan.id !== 2 }">
                    <h6 class="font-small fw-medium uppercase letter-spacing-1">{{ plan.name }}</h6>
                    <div class="mt-3">
                    <h1 class="line-height-100 fw-medium mb-0 text-color-theme">{{ plan.price }}</h1>
                    <span>monthly</span>
                    </div>
                    <ul class="list-unstyled mt-4">
                    <li *ngFor="let feature of plan.features">{{ feature }}</li>
                    </ul>
                    <a class="button button-md button-gradient-1 button-rounded mt-4" routerLink="/contact-us">Choose Plan</a>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Pricing section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Sliding Text -->
<section class="section-sm">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Contact section -->
<div class="section pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                <h6 class="d-inline-block bg-gray border-radius-2 px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Get in Touch</span></h6>
                <h2 class="fw-semi-bold mb-0 text-capitalize">Elevating Brands with Timeless Design.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-4">
            <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 text-center">
                <div class="contact-form">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group text-start">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group text-start">
                                    <input class="border-radius" type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-start">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea class="border-radius" name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->
